// src/components/ResetPassword.jsx
import React, { useEffect, useState } from "react";
// import { ValidateResetPasswordToken } from "../services/api"; // Adjust this based on your project structure
import { useSearchParams } from "react-router-dom";
import axios from "axios";
// import "./ResetPassword.css";
import styles from "./ResetPassword.module.css";
import logo from "../../../assets/img/Ini_Logo_1.png";
import logo1 from "../../../assets/img/437dc99a.jpg";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  const [apiLogo, setApiLogo] = useState(null); // State for API logo

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const key = searchParams.get("Key");
  const msid = searchParams.get("MSID");
  const userName = searchParams.get("userName");

  // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  // Function to fetch logo from API without authentication
  const fetchLogoFromAPI = async () => {
    try {
      // Create a new axios instance without authentication interceptors
      const logoAxios = axios.create({
        baseURL: window.runtimeConfig?.REACT_APP_BASEURL_ACCESS_CONTROL1 || '',
        responseType: 'blob', // Important: Set responseType to 'blob' for binary data
      });

      const response = await logoAxios.get('/api/Login/GetLogo');
      
      if (response.status === 200) {
        // Convert blob to data URL for display
        const blob = response.data;
        const reader = new FileReader();
        
        reader.onloadend = () => {
          const dataUrl = reader.result;
          setApiLogo(dataUrl);
          console.log('Logo fetched successfully and converted to data URL');
        };
        
        reader.readAsDataURL(blob);
      }
    } catch (error) {
      console.error('Error fetching logo from API:', error);
      // Fallback to static logo if API fails
      setApiLogo(null);
    }
  };

  //   useEffect(() => {
  //     validateToken();
  //   }, [key, msid]);

  useEffect(() => {
    const runValidation = async () => {
      if (key && msid) {
        const result = await validateToken(key, msid);

        if (result.success) {
          setIsLoading(false);
          setValidated(true);
          console.log("Token validated:", result.data);
          // you can store result in state or perform other operations
        } else {
          console.error("Token validation failed:", result.error);
          // handle error, maybe redirect or show message
        }
      }
    };

    runValidation();
  }, [key, msid]);

  // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
  useEffect(() => {
    fetchLogoFromAPI();
  }, []);

  const validateToken = async (key, msid) => {
    // const url = `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/Login/ResetPassword?Key=${key}&MSID=${msid}&LoginID=21&NewPassword=aqzqaz&ConfirmPassword=qazzaqz`;
    const url = `/api/Login/ValidateResetPasswordToken?Key=${key}&MSID=${msid}`;

    try {
      const response = await AxiosInstance1.post(url, { key, msid });

      const res = response?.data;

      if (res?.type === 0 && res?.message === "ValidUser") {
        // console.log("Email sent successfully:", response.data);
        return { success: true, data: res };
      } else {
        console.warn("Unexpected response status:", response.status);
        return {
          success: false,
          error: `Unexpected status: ${response.status}`,
        };
      }
    } catch (error) {
      console.error("Failed to send email:", error);
      return { success: false, error: error.message || "Unknown error" };
    }
  };

  const getEncryptedUserNameOnChange = async (username) => {
    const response = await AxiosInstance1.get(
      `/api/Login/getEncryptedUserNameOnChange?UserName=${encodeURIComponent(
        username
      )}`
    );
    if (response.status !== 200) throw new Error("Failed to get encrypted username");
    return response?.data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords does not match.");
      return;
    }

    try {
      var username = userName;
      const encUser = await getEncryptedUserNameOnChange(username);
      const encryptedUsername = String(encUser).split("||")[0];
      let encryptedNewPassword = "";
      let encryptedConfirmPassword = "";

      // Encrypt new and confirm passwords
      for (let i = newPassword.length - 1; i >= 0; i--) {
        encryptedNewPassword += newPassword[i] + encryptedUsername + "|";
        encryptedConfirmPassword +=
          confirmPassword[i] + encryptedUsername + "|";
      }
      encryptedNewPassword = encryptedNewPassword.slice(0, -1);
      encryptedConfirmPassword = encryptedConfirmPassword.slice(0, -1);

      //   const response = await fetch(
      //     `${
      //       window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1
      //     }/api/Login/ResetPassword?LoginID=${encodeURIComponent(
      //       username
      //     )}&NewPassword=${encodeURIComponent(
      //       encryptedNewPassword
      //     )}&ConfirmPassword=${encodeURIComponent(encryptedConfirmPassword)}`,
      //     {
      //       method: "POST",
      //     }
      //   );
      //   if (!response.ok) throw new Error("Failed to get encrypted username");

      var url = `/api/Login/ResetPassword?Key=${key}&MSID=${msid}&NewPassword=${encryptedNewPassword}&ConfirmPassword=${encryptedConfirmPassword}`;
      const res = await AxiosInstance1.post(url, {
        // method: "POST",
      });

      const response = res?.data;

      // if (!response.ok) throw new Error("Failed to reset password");
      if (response?.type === 0) {
        // console.log("Email sent successfully:", response.data);
        setErrorMessage("");
        setMessage(`${response?.data}`);
        setNewPassword("");
        setConfirmPassword("");
      } else if (response?.type === 1) {
        // const res = await response.json();
        setMessage("");
        setErrorMessage(response?.data);
      } else {
        // console.warn("Unexpected response status:", response.status);
        setMessage("");
        setErrorMessage(`Unexpected status: ${response.status}`);
      }
    } catch (error) {
      setMessage("");
      setErrorMessage(error.message || "An error occurred.");
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (!validated) return <div className="message">{message}</div>;

  return (
    // <div className="d-flex justify-content-center align-items-center vh-100">
    <div
      className={`d-flex justify-content-center align-items-center vh-100 ${styles.resetPage}`}
    >
      {/* <div className="reset-container"> */}
      <div className={styles.resetContainer}>
        <div className="text-center mb-1 d-flex align-items-center">
          <div className="row">
            {/* <div
              className="col-6 col-sm-6"
              style={{
                display: "flex",
                alignItems: "center",
                borderRight: "1px solid #ccc",
              }}
            > */}
            <div className={`col-6 col-sm-6 ${styles.logoContainer}`}>
              <img
                src={logo}
                alt="Winsights Logo"
                // className="img-fluid"
                // style={{
                //   width: "50%",
                //   flex: 1,
                //   // borderRight: "1px solid #ccc",
                //   // paddingRight: "10px",
                // }}
                className={`img-fluid ${styles.logoImage}`}
              />
            </div>
            {/* <div
              className="col-6 col-sm-6"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            > */}
            <div className="col-6 col-sm-6">
              {/* Added by Gauri to show logo on login page from Company Information page on 25-09-2025 */}
              {apiLogo ? (
                <img
                  src={apiLogo}     // Added by Gauri to show logo on login page from Company Information page on 25-09-2025
                  alt="Company Logo"
                  // className="img-fluid"
                  // style={{
                  //   width: "50%",
                  //   flex: 1,
                  //   height: "80px",
                  //   // paddingRight: "10px",
                  // }}
                  className={`img-fluid ${styles.secondLogo}`}
                />
              ) : (
                <div
                  className={`img-fluid ${styles.secondLogo}`}
                  style={{
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* Blank space when no logo */}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="text-center">
          <h4>
            <strong>Reset Password</strong>
          </h4>
          <p>You can reset your password here.</p>
        </div>
        <form onSubmit={handleSubmit}>
          {/* <div className="form-group"> */}
          <div className={styles.formGroup}>
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          {/* <div className="form-group"> */}
          <div className={styles.formGroup}>
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className={styles.resetButton}>
            Reset Password
          </button>
          {/* <div className="message" style={{ color: message ? "green" : "red" }}> */}
          <div
            className={styles.message}
            style={{ color: message ? "green" : "red" }}
          >
            {message ? message : errorMessage}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
